import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { IS_DEVELOPMENT } from 'config';
import Visibility from 'lib/browser/visibility';
import { fetchAppVersion } from 'store/ui/uiActions';

const POLLING_INTERVAL = 60000; // 60 seconds

const AppVersionFetcher = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (IS_DEVELOPMENT) return;

    const poller = Visibility.every(POLLING_INTERVAL, () => dispatch(fetchAppVersion()));
    dispatch(fetchAppVersion());

    return () => Visibility.stop(poller);
  }, [dispatch]);

  return null;
};

export default AppVersionFetcher;
